import React, { useState } from 'react';
import { Instagram, Youtube, Facebook, Menu, X, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const socialIcons = [{
    Icon: Instagram,
    label: 'Instagram',
    href: 'https://instagram.com'
  }, {
    Icon: Youtube,
    label: 'YouTube',
    href: 'https://youtube.com'
  }, {
    Icon: Facebook,
    label: 'Facebook',
    href: 'https://facebook.com'
  }];
  const menuItems = [{
    label: 'WATCH',
    subItems: [{
      label: 'Season 1',
      href: 'https://www.amazon.com/gp/video/detail/B0G2RVNJMC'
    }, {
      label: 'Season 2',
      href: 'https://www.amazon.com/gp/video/detail/B0G2RVNJMC'
    }]
  }, {
    label: 'ABOUT',
    href: '#'
  }, {
    label: 'NEWS',
    href: '#'
  }, {
    label: 'PARTNERS',
    href: '#'
  }, {
    label: 'MORE BEAST',
    href: '#'
  }];
  return <>
      <header className="fixed top-0 left-0 right-0 z-50 px-6 py-6 flex justify-end items-center bg-gradient-to-b from-black/90 to-transparent pointer-events-none" data-id="element-44">
        <div className="flex items-center gap-6 md:gap-8 pointer-events-auto" data-id="element-45">
          {/* Social Icons */}
          <nav className="hidden md:flex items-center space-x-6" data-id="element-46">
            {socialIcons.map(({
            Icon,
            label,
            href
          }) => <motion.a key={label} href={href} target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.2,
            color: '#ffffff'
          }} className="text-[#d4af37] transition-colors drop-shadow-md" aria-label={label} data-id="element-47">
                <Icon size={24} strokeWidth={2} data-id="element-48" />
              </motion.a>)}
          </nav>

          {/* Hamburger Menu */}
          <motion.button onClick={() => setIsMenuOpen(true)} whileHover={{
          scale: 1.1
        }} whileTap={{
          scale: 0.95
        }} className="text-white hover:text-[#d4af37] transition-colors drop-shadow-md bg-black/20 p-2 rounded-full backdrop-blur-sm" aria-label="Menu" data-id="element-49">
            <Menu size={36} strokeWidth={2} data-id="element-50" />
          </motion.button>
        </div>
      </header>

      {/* Full Screen Menu Overlay */}
      <AnimatePresence data-id="element-51">
        {isMenuOpen && <motion.div initial={{
        opacity: 0,
        x: '100%'
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed inset-0 z-[60] bg-[#0f0f1a] flex flex-col" data-id="element-52">
            {/* Close Button */}
            <div className="flex justify-end p-8" data-id="element-53">
              <motion.button onClick={() => setIsMenuOpen(false)} whileHover={{
            scale: 1.1,
            rotate: 90
          }} whileTap={{
            scale: 0.95
          }} className="text-white hover:text-[#ffd700] transition-colors" data-id="element-54">
                <X size={48} strokeWidth={1.5} data-id="element-55" />
              </motion.button>
            </div>

            {/* Menu Items */}
            <div className="flex-1 flex flex-col justify-center items-center px-6 overflow-y-auto" data-id="element-56">
              <nav className="flex flex-col items-center space-y-8 md:space-y-10 w-full max-w-2xl" data-id="element-57">
                {menuItems.map((item, index) => <motion.div key={item.label} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.1 + 0.2
            }} className="w-full text-center group" data-id="element-58">
                    {item.subItems ? <div className="flex flex-col items-center" data-id="element-59">
                        <span className="font-oswald text-4xl md:text-6xl font-bold text-white uppercase tracking-widest mb-4 group-hover:text-[#ffd700] transition-colors cursor-default" data-id="element-60">
                          {item.label}
                        </span>
                        <div className="flex gap-6 md:gap-10" data-id="element-61">
                          {item.subItems.map(sub => <a key={sub.label} href={sub.href} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white font-oswald text-xl uppercase tracking-wider flex items-center transition-colors" data-id="element-62">
                              <ChevronRight className="w-4 h-4 mr-1 text-[#ffd700]" data-id="element-63" />
                              {sub.label}
                            </a>)}
                        </div>
                      </div> : <a href={item.href} className="block font-oswald text-4xl md:text-6xl font-bold text-white uppercase tracking-widest hover:text-[#ffd700] transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-64">
                        {item.label}
                      </a>}
                  </motion.div>)}
              </nav>
            </div>

            {/* Footer Socials in Menu */}
            <div className="p-8 flex justify-center gap-8 border-t border-white/10" data-id="element-65">
              {socialIcons.map(({
            Icon,
            label,
            href
          }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#ffd700] transition-colors" data-id="element-66">
                  <Icon size={24} data-id="element-67" />
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}